import React from "react";
import "css/BlurLoader.css";

export default function BlurLoader() {
  return (
    <h2 className="blur-loader">LOADING</h2>
  );
}
